import { render, staticRenderFns } from "./nutritiousDiningOpen.vue?vue&type=template&id=323109fa&scoped=true&"
import script from "./nutritiousDiningOpen.vue?vue&type=script&lang=js&"
export * from "./nutritiousDiningOpen.vue?vue&type=script&lang=js&"
import style0 from "./nutritiousDiningOpen.vue?vue&type=style&index=0&id=323109fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323109fa",
  null
  
)

export default component.exports